import React from 'react';
import { 
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink
     } from 'reactstrap';
import {menu} from '../requests/req_menu';
import {checkUser, getUser, LogOut} from '../requests/utils';
import '../styles/Header.css';
export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = { MN: null, isOpen: false};
        this.genUser = this.genUser.bind(this);
       this.goInicio = this.goInicio.bind(this);
        this.irSeccion = this.irSeccion.bind(this);
        this.clicklogin = this.clicklogin.bind(this);
        this.clickRegis = this.clickRegis.bind(this);
        this.pintaSecciones = this.pintaSecciones.bind(this);
        this.toggle=this.toggle.bind(this);
       
    }
    toggle() {
        this.setState({
          isOpen: !this.state.isOpen
        });
     
      }
    componentDidMount(){
        //let url = window.location.href;
      
        if(checkUser()){
            this.setState({MN: menu});
        }
    }
 
    //Generar menú, falta condicionar a Login
    pintaSecciones(){
        if(this.state.MN !== null){
            return this.state.MN.map((m, index)=>{
                return( 
                    <NavItem className="ARC_H_Menu" key={index}  >
                        <NavLink  key={index} onClick={(e)=> {this.irSeccion(e)}} datoseccion={m.desc_url}>
                            <img  src={process.env.PUBLIC_URL + '/images/' + m.icono} datoseccion={m.desc_url} alt=' '/>
                            <br/> 
                            <label className='lbl_mn Customlabel'   datoseccion={m.desc_url} style={{wordWrap:''}}>{m.nombre}</label>
                        </NavLink>
                    </NavItem>
                    // <Button key={index} onClick={(e)=> this.irSeccion(e)} datoseccion={m.desc_url}><img src={process.env.PUBLIC_URL + '/images/' + m.icono} datoseccion={m.desc_url} alt=' '/><br/> <label className='lbl_mn' datoseccion={m.desc_url}>{m.nombre}</label></Button>
                 );
            });
        }
    }

    //Ir a sección de acuerdo al botón
    irSeccion(e){
        this.setState({
            isOpen: !this.state.isOpen
          });
        var elm = e.target,
            ur = elm.getAttribute('datoseccion'),
            btn = document.getElementById('Id_' + ur);
            btn.click();
    }

    //Ir a Login/Iniciar sesión
    clicklogin(){
        this.setState({
            isOpen: !this.state.isOpen
          });
        var btn = document.getElementById('Id_login');
        btn.click();
    }

    //Ir a Login/Registrar
    clickRegis(){
        this.setState({
            isOpen: !this.state.isOpen
          });
        var btn = document.getElementById('Id_Registrarse');
        btn.click();
    }

    goInicio(){
        var a = window.location,
            o = a.origin;
      window.location.replace(o);
    }

    genUser(){
        var usr = getUser();
        if(usr !== undefined){
            return (

                <Navbar color="dark" dark expand="md">
                <NavbarBrand href="/#">
                    <div className='ARC_H_Icono' >
                     <img src={process.env.PUBLIC_URL + '/images/mireclu blanco.png'} alt=' ' />
                     <label className='Hide_All' id='lbl_util'></label>
                     </div>
                </NavbarBrand>
                <NavbarToggler onClick={this.toggle}  />
                    <Collapse isOpen={this.state.isOpen}  navbar>
                        <Nav className="ml-auto" navbar>
                            {this.pintaSecciones()}
                        
                            <NavItem className="ARC_H_U_DivImg"  >
                                    <img
                                    //   src={
                                    //     usr.foto === ""
                                    //       ? process.env.PUBLIC_URL + "/images/default-avatar.png"
                                    //       : usr.foto
                                    //   }
                                    src={
                                        localStorage.getItem('foto')!=null?localStorage.getItem('foto'):process.env.PUBLIC_URL + "/images/default-avatar.png"
                                        //  localStorage.getItem('foto')!=null?localStorage.getItem('foto')+'?'+ new Date().getTime():process.env.PUBLIC_URL + "/images/default-avatar.png"   
                                    }
                                    alt=" "
                                    id="img_header"
                                    />
                            </NavItem>
                            <NavItem className="ARC_H_U_DivImg"  >
                                <NavLink color="secondary"  className="btn_nothing" onClick={e => {LogOut(e)}}>
                                  Cerrar Sesión
                                </NavLink>
                            </NavItem> 
                                
                        </Nav>
                    </Collapse>
                </Navbar>
                
            //   <div className="ARC_H_U_DivImg" style={{display:'inline-block',whiteSpace:'nowrap'}}>
            //     <img
            //     //   src={
            //     //     usr.foto === ""
            //     //       ? process.env.PUBLIC_URL + "/images/default-avatar.png"
            //     //       : usr.foto
            //     //   }
            //     src={
            //         localStorage.getItem('foto')!=null?localStorage.getItem('foto')+'?'+ new Date().getTime():process.env.PUBLIC_URL + "/images/default-avatar.png"

            //     }
            //       alt=" "
            //       id="img_header"
            //     />
            //     <Button
            //       color="secondary"
            //       className="btn_nothing"
            //       onClick={e => LogOut(e)}
            //     >
            //       Cerrar Sesión
            //     </Button>
            //     <br />
            //   </div>
            );
        }else{
           
            return(
                <Navbar color="dark" dark expand="md">
                <NavbarBrand href="/#">
                    <div className='ARC_H_Icono' > 
             
                     <img src={process.env.PUBLIC_URL + '/images/mireclu blanco.png'} alt=' ' />
                     <label className='Hide_All' id='lbl_util'></label>
                     </div>
                </NavbarBrand>
                <NavbarToggler onClick={this.toggle}  />
                    <Collapse isOpen={this.state.isOpen}  navbar>
                        <Nav className="ml-auto" navbar>
                            {this.pintaSecciones()}
                        
                            <NavItem className="ARC_H_U_DivBtn"  >
                                <NavLink color='secondary' className='btn_nothing' onClick={this.clicklogin}>
                                    Iniciar Sesión
                                
                                </NavLink>
                            </NavItem>
                            <NavItem className="ARC_H_U_DivBtn"  >
                                <NavLink color='secondary' id="btnNewlogin" className='btn_nothing' onClick={this.clickRegis}>
                                    Crear cuenta
                                
                                </NavLink>
                            </NavItem> 
                                
                        </Nav>
                    </Collapse>
                </Navbar>


                // <div className='ARC_H_U_DivBtn'>
                //     <Button color='secondary' className='btn_nothing' onClick={(e)=> this.clicklogin(e)}>Iniciar Sesión</Button>
                //     <Button color='secondary' className='btn_nothing' onClick={(e)=> this.clickRegis(e)}>Crear cuenta</Button>
                // </div>
            );
        }
    }

    render() {
        return (
        //   <div className='ARC_Header'>
        //     <div className='ARC_H_Icono' onClick={(e)=> this.goInicio(e)}>
        //         <img src={process.env.PUBLIC_URL + '/images/mireclu blanco.png'} alt=' ' />
        //         <label className='Hide_All' id='lbl_util'></label>
        //     </div>
        //     <div className='ARC_H_Menu'>{this.pintaSecciones()}</div>
        //     <div className='ARC_H_User'>
        //         {this.genUser()}
        //     </div>
        //   </div>

        <div>
                 {this.genUser()}
        </div>

        );
    }
}